import React from 'react';

import { Flex } from '@rover/kibble/core';
import type { PersonalizationTag } from '@rover/rsdk/src/apiClient/latest/model/personalizationTag';

import SkillTag from './SkillTag';

const MAX_TAGS = 3;

export type Props = { tags?: PersonalizationTag[] | null };

const SkillTagRow = ({ tags }: Props): React.ReactElement | null => {
  if (!tags || tags.length === 0) return null;
  return (
    <Flex
      flexDirection="row"
      flexWrap="wrap"
      gap="2x"
      pt="4x"
      alignItems="flex-start"
      justifyContent="flex-start"
      data-testid="skill-tag-row"
    >
      {tags.slice(0, MAX_TAGS).map((t) => (
        <SkillTag key={t.id} label={t.label} />
      ))}
    </Flex>
  );
};

export default SkillTagRow;
